/** Фиксированный срок для оценки ежемесячного платежа на mx_2. */
export const MX_ESTIMATED_PAYMENT_MONTHS = 12

/**
 * Коэффициент надбавки к сумме при оценке платежа.
 * Полная куота: 5200 → 451 (5200 * 1.04 / 12), в UI показываем половину комиссии: 226.
 * Итог к погашению: сумма + куота (5200 + 226 = 5426).
 */
export const MX_ESTIMATED_PAYMENT_MARKUP = 1.04

/** Оценочная куота / комиссия: ((сумма * markup) / месяцы) / 2. */
export function estimateMonthlyPayment(
  amount: number,
  months: number = MX_ESTIMATED_PAYMENT_MONTHS,
  markup: number = MX_ESTIMATED_PAYMENT_MARKUP
): number {
  if (!Number.isFinite(amount) || amount <= 0 || months <= 0) return 0
  const safeMarkup = Number.isFinite(markup) && markup > 0 ? markup : 1
  const fullCuota = Math.round((amount * safeMarkup) / months)
  return Math.round(fullCuota / 2)
}

/** Сумма к погашению: запрошенная сумма + куота. */
export function estimateTotalToPay(
  amount: number,
  months: number = MX_ESTIMATED_PAYMENT_MONTHS,
  markup: number = MX_ESTIMATED_PAYMENT_MARKUP
): number {
  if (!Number.isFinite(amount) || amount <= 0) return 0
  return amount + estimateMonthlyPayment(amount, months, markup)
}
